import { buttonRowExpandsHorizontally } from '../domain/button-row-layout';
import { blockWidthAlignMargins } from '../domain/block-width';
import { renderButtonRowBlock } from '../render/blocks/button-row';
import { ButtonRowBlockSettings } from '../settings/blocks/button-row';
import { defineBlockRegistryEntry } from './defineEntry';
import { buttonRowBlockDefinition } from '../domain/blocks/button-row';

export const buttonRowBlockRegistryEntry = defineBlockRegistryEntry(
  buttonRowBlockDefinition,
  renderButtonRowBlock,
  ButtonRowBlockSettings,
  {
    boxStyle: block =>
      block.type === 'buttonRow'
        ? buttonRowExpandsHorizontally(block)
          ? { width: '100%', maxWidth: '100%' }
          : {
              width: 'fit-content',
              maxWidth: '100%',
              ...blockWidthAlignMargins(block.align),
            }
        : undefined,
  },
);
